var map = {
	"./en/Slide1.mp3": "35b6",
	"./en/Slide10.mp3": "090f",
	"./en/Slide11.mp3": "b49e",
	"./en/Slide12.mp3": "e2e9",
	"./en/Slide13.mp3": "6301",
	"./en/Slide14.mp3": "d6d4",
	"./en/Slide15.mp3": "29f3",
	"./en/Slide16.mp3": "ec69",
	"./en/Slide17.mp3": "5aad",
	"./en/Slide18.mp3": "4024",
	"./en/Slide2.mp3": "61aa",
	"./en/Slide4.mp3": "9b06",
	"./en/Slide5.mp3": "6bd9",
	"./en/Slide6.mp3": "785a",
	"./en/Slide7.mp3": "dd6f",
	"./en/Slide8.mp3": "47b3",
	"./en/Slide9.mp3": "c7c2",
	"./es/Slide1.mp3": "6f3e",
	"./es/Slide10.mp3": "17a8",
	"./es/Slide11.mp3": "f191",
	"./es/Slide12.mp3": "11e8",
	"./es/Slide13.mp3": "67e2",
	"./es/Slide14.mp3": "533b",
	"./es/Slide15.mp3": "74f2",
	"./es/Slide16.mp3": "e720",
	"./es/Slide17.mp3": "13ef",
	"./es/Slide18.mp3": "1939",
	"./es/Slide2.mp3": "3c03",
	"./es/Slide4.mp3": "73b9",
	"./es/Slide5.mp3": "8be9",
	"./es/Slide6.mp3": "6128",
	"./es/Slide7.mp3": "24f8",
	"./es/Slide8.mp3": "07bd",
	"./es/Slide9.mp3": "b40d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "256b";